import { IconBadge } from '../IconBadge/index.js';
import { FIAT_ICON_MAP } from './constants.js';
import { jsx } from '@emotion/react/jsx-runtime';

const FiatIcon = ({
  size = 'lg',
  symbol
}) => {
  const icon = FIAT_ICON_MAP[symbol];
  return jsx(IconBadge, {
    size: size,
    icon: icon
  });
};
FiatIcon.displayName = 'FiatIcon';

export { FiatIcon };
